module.exports = __webpack_public_path__ + "static/media/check.a3e50476.svg";